import { Schema } from 'rsuite'

const { StringType, ArrayType, NumberType } = Schema.Types

export const ProductFormValidationModel = Schema.Model({
  name: StringType().isRequired('Заполните название'),
  xid: StringType()
    .isRequired('Заполните артикул')
    .minLength(3, 'Минимальное количество символов 3'),
  weight: NumberType()
    .min(0, 'Вес не может быть отрицательным')
    .isRequired('Заполните вес'),
  price_type: StringType().isRequired('Выберите тип товара'),
  shop_ids: ArrayType()
  // price checks
  // singlePrice: NumberType().addRule((value, otherFields) => {
  //   return otherFields.useSinglePrice ? value >= 0 : true
  // }, 'Установите цену больше 0')
})
